"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var AppPaySystemEditor_1 = require("./component/AppPaySystemEditor");
var AppPaySystemsList_1 = require("./component/AppPaySystemsList");
var AppPaySystemPayWaysList_1 = require("./component/AppPaySystemPayWaysList");
var AppPaySystemPayWayEditor_1 = require("./component/AppPaySystemPayWayEditor");
var PAppPaySystemsList = /** @class */ (function (_super) {
    __extends(PAppPaySystemsList, _super);
    function PAppPaySystemsList(props) {
        return _super.call(this, props) || this;
    }
    PAppPaySystemsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.brandsList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_brands: data.data
            });
        });
        this.SID_CT = this.props.cryptoCurrencyTypesList.Subscribe("*", function (id, data) {
            _this.setState({
                avail_cryptocurrency: data.data
            });
        });
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({
                avail_currency: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        }, function () {
            _this.props.brandsList.LoadData();
            _this.props.cryptoCurrencyTypesList.LoadData();
            _this.props.listAppCurrency.LoadData();
        });
    };
    PAppPaySystemsList.prototype.componentWillUnmount = function () {
        this.props.brandsList.UnSubscribe(this.SID_AB);
        this.props.cryptoCurrencyTypesList.UnSubscribe(this.SID_CT);
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PAppPaySystemsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PAppPaySystemsList.prototype.onNewDetailClick = function () {
        this.setState({ edit_mode: "NEW-DETAIL", record: null });
    };
    PAppPaySystemsList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", rootRecord: id });
    };
    PAppPaySystemsList.prototype.onEditDetailClick = function (id) {
        this.setState({ edit_mode: "EDIT-DETAIL", record: id });
    };
    PAppPaySystemsList.prototype.onDetailClick = function (id) {
        this.setState({ edit_mode: "LIST-DETAIL", rootRecord: id });
    };
    PAppPaySystemsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PAppPaySystemsList.prototype.onGoBackToDetailClick = function () {
        this.setState({ edit_mode: "LIST-DETAIL", record: null });
    };
    PAppPaySystemsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PAppPaySystemsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(AppPaySystemEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availBrands: this.state.avail_brands }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(AppPaySystemEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this), availBrands: this.state.avail_brands }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(AppPaySystemsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, onDetailsClick: this.onDetailClick.bind(this) }));
        }
        if (this.state.edit_mode === "LIST-DETAIL") {
            return (React.createElement(AppPaySystemPayWaysList_1.default, { data: this.props.dataPayWays, state: this.props.state, onNewClick: this.onNewDetailClick.bind(this), onEditClick: this.onEditDetailClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, root: this.state.rootRecord, onGoBackClick: this.onGoBackClick.bind(this) }));
        }
        if (this.state.edit_mode === "EDIT-DETAIL") {
            return (React.createElement(AppPaySystemPayWayEditor_1.default, { data: this.props.dataPayWays, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackToDetailClick.bind(this), rootRecord: this.state.rootRecord, availWalletCurrencyTypes: this.state.avail_cryptocurrency, availAppCurrency: this.state.avail_currency }));
        }
        if (this.state.edit_mode === "NEW-DETAIL") {
            return (React.createElement(AppPaySystemPayWayEditor_1.default, { data: this.props.dataPayWays, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackToDetailClick.bind(this), rootRecord: this.state.rootRecord, availWalletCurrencyTypes: this.state.avail_cryptocurrency, availAppCurrency: this.state.avail_currency }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PAppPaySystemsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PAppPaySystemsList.getPageDescription = function (state) {
        //let lang = CfgCssClassListLangFactory.getLangInstance("RU");//state.getLang()
        return {
            icon: "donate",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_paysystem_services + "-id",
            itemTitle: "Сервисы",
            route: routes_1.routes.page_paysystem_services,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PAppPaySystemsList;
}(React.Component));
exports.default = PAppPaySystemsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem/ui/PAppPaySystemsList.tsx
// module id = 2568
// module chunks = 0